<template>
  <div
    class="error-tooltip-container hidden-visibility"
    ref="tooltip"
    @mouseenter="visible = true"
    @mouseleave="visible = false"
  >
    <span class="error-icon">
      <img
        class="icon-in-button"
        :src="require('@/assets/dashboard/triangle-exclamation-solid-full-red.svg')"
        alt="Icon"
      />
    </span>
    <div v-if="visible" class="error-popup">
      {{ text }}
    </div>
  </div>
</template>

<script>

export default {
  props: {
    text: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      visible: false
    };
  },
  methods: {
    togglePopup() {
      this.visible = !this.visible;
    },
    handleClickOutside(event) {
      if (this.visible && !this.$refs.tooltip.contains(event.target)) {
        this.visible = false;
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }
};
</script>

<style scoped src="@/styles/ErrorTooltip.css">

</style>